import React from 'react';
import './DashboardDetails.scss';
import { useQuery } from '@apollo/client/react';
import { GET_ALL_CUSTOMERSLIST, GET_CUSTOMERS_CONTACT } from '../../graphql/client/queries';
import { PermissionEnum } from '../../types/PermissionEnum';
import * as CustomerListActions from '../../store/actions/customerList';
import { useStoreContext } from '../App/StoreProvider';
import { useAuthContext } from '../Auth/AuthProvider';
import { GetAllCustomerList, GetCustomersContact } from '../../types/schemaTypes';
import { Loading } from '../_common';

const DashboardDetails = (): React.JSX.Element => {
    const [state, dispatch] = useStoreContext();
    const authContext = useAuthContext();
    const {
        auth: { user },
        customerList: { customerList, customer },
    } = state;

    const opsCustomer = authContext.userHasPermission(PermissionEnum.Customer);
    let selectedCustomer = 0;
    const userProfile = user.profile;
    if (opsCustomer && customer === 0 && userProfile && userProfile.role === 'Customer') {
        const userProfile = user.profile;
        const customerId = userProfile.Customer;
        selectedCustomer = Number(customerId);
        dispatch(CustomerListActions.setCustomerID(selectedCustomer));
    }

    const input = {
        search: '',
        customerId: opsCustomer ? selectedCustomer : 0,
    };

    const { data } = useQuery<GetAllCustomerList>(GET_ALL_CUSTOMERSLIST, {
        variables: { input },
        skip:
            customerList.length > 0 ||
            (opsCustomer && customer === 0 && userProfile && userProfile.role === 'Customer'),
    });

    if (customerList.length === 0 && data && data.getAllCustomerList && data.getAllCustomerList.length !== 0) {
        const customerusersData = data.getAllCustomerList;
        dispatch(CustomerListActions.setCustomerList(customerusersData));
    }

    const contactVariables = {
        input: {
            customerId: customer,
        },
    };

    const { data: contactData, loading: contactLoading } = useQuery<GetCustomersContact>(GET_CUSTOMERS_CONTACT, {
        variables: contactVariables,
        skip: customer === 0,
        fetchPolicy: 'network-only',
    });

    return (
        <div className="Dashboard-Details-Container">
            {customer != 0 && <div className="Loading-Class">{contactLoading && <Loading />}</div>}
            {!contactLoading && (
                            <div className="Row">
                                <div className="Column">
                                    <label className="Details-Headings">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;My Details</label>
                                    <div className="Details-Table">
                                        <div className="Details-Keys">Parent Number</div>
                                        <div className="Details-Values">{customer}</div>
                                        <div className="Details-Keys">Address</div>
                                        <div className="Details-Values">{contactData?.getCustomersContact?.address}</div>
                                        <div className="Details-Keys">City, State & Zip</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.city}
                                            {contactData?.getCustomersContact?.state
                                                ? `, ${contactData.getCustomersContact.state}`
                                                : ''}
                                            {contactData?.getCustomersContact?.postalCode
                                                ? ` & ${contactData.getCustomersContact.postalCode}`
                                                : ''}
                                        </div>
                                        <div className="Details-Keys">Country & County</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.country}
                                            {contactData?.getCustomersContact?.county
                                                ? `, ${contactData?.getCustomersContact?.county}`
                                                : ''}
                                        </div>
                                        <div className="Details-Keys">Electronic Addresses</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.electronicDetails?.map(info => (
                                                <label className="address-label" key={info?.emailType}>
                                                    {info?.emailType}
                                                    <br></br>
                                                    {info?.emailAddress}
                                                </label>
                                            ))}
                                        </div>
                                        <div className="Details-Keys">Payment Terms</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.paymentTerms
                                                ? `Net ${contactData.getCustomersContact.paymentTerms} Days`
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="vertical_dotted_line"></div>
                                <div className="Column">
                                    <label className="Details-Headings">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contacts</label>
                                    <div className="Details-Table">
                                        <div className="Details-Keys">Sales Representative</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.contactDetails?.salesRepName}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.salesRepEmail}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.salesRepPhoneNumber}
                                        </div>

                                        <div className="Details-Keys">Customer Service</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.contactDetails?.custServiceName}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.custServiceEmail}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.custServicePhoneNumber}
                                        </div>
                                        <div className="Details-Keys">Credit Analyst</div>
                                        <div className="Details-Values">
                                            {contactData?.getCustomersContact?.contactDetails?.creditAnalystName}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.creditAnalystEmail}
                                            <br></br>
                                            &nbsp;&nbsp;
                                            {contactData?.getCustomersContact?.contactDetails?.creditAnalystPhoneNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
            )}
        </div>
    );
};

export default DashboardDetails;
